import { connect } from 'react-redux';
import MasterMapel from '../../views/Settings/MasterMapel.view';
import {
  getUsernameOptions, getUserGroups, getSchoolUnitsOptions, getParamPerwakilan,
} from '../../states/thunks/options.thunk';
import { listBlockUnits, setIsActive, listMasterMapel } from '../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleListBlockUnits: (payload, goback) => dispatch(listBlockUnits(payload, goback)),
    getUsernameOptions: payload => dispatch(getUsernameOptions(payload)),
    getUserGroups: payload => dispatch(getUserGroups(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getParamPerwakilan: payload => dispatch(getParamPerwakilan(payload)),
    handleListMasterMapel: (payload, goback) => dispatch(listMasterMapel(payload, goback)),
    handleSaveActiveMapel: (payload, goback) => dispatch(setIsActive(payload, goback)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MasterMapel);
